module.exports = __webpack_public_path__ + "images/banners/category_estimate/banner_category_bulk_default_d0777f9aeba1a9f40197f02280a565b8.png";